import { IPostComments } from './notice-board';

export interface VisitorData {
  orgID: string;
  visitorId: string;
  firstName: string;
  lastName: string;
  gender: string;
  email: string;
  phoneNumber: string;
  identityId: string;
  carRegistration: string;
  profilePicture: string;
  visitorAddDate: Date;
  securityStatus: number;
  visitorAddress: string;
  lastModifiedDate?: Date | null; // Optional field
  lastModifiedDateByUserId: string;
  visitorCreatedByUserId: string;
}

export interface Visitor {
  email: string;
  firstName: string;
  hostUserId: string;
  hostName: string;
  identityID: string;
  inviteCreateDate: string;
  inviteCreatedByUserID: string;
  lastName: string;
  carRegistration: string;
  orgID: string;
  phoneNumber: string;
  profilePicture: string;
  purpose: string;
  securityStatus: number;
  visitDateTime: string;
  visitorAddress: string;
  visitorID: string;
  securityCode?: string;
  securityKey?: string;
  qrCode?: string;
  isHostVerified?: string;
  isGateEntry?: string;
  isPreApproved?: string;
  checkIn?: string;
  checkOut?: string;
  guardAtDutyID?: string;
  guardAtDutyName?: string;
  ePassValidity?: string;
  visitorTimline?: string;
  visitorCategory?: string;
  visitorTimlineListUI?: VisitorTimeline[];
  timer?: number;
  visitorType?: string;
  meetingComments?: string;
  inProgressStatusTime?: string;
  completeStatusTime?: string;
  timerValue?: string;
  visitorCommentsTimeline?: string;
  visitorTimelineGraph?: VisitorStatusTimeline[];
  visitorComments?: IPostComments[];
  isTwoFactor?: boolean;
  isLocationVerify?: boolean;
  visitorLocation?: string;
}
export const initVisitor: Visitor = {
  email: null,
  firstName: null,
  hostUserId: null,
  hostName: null,
  identityID: null,
  inviteCreateDate: null,
  inviteCreatedByUserID: null,
  lastName: null,
  carRegistration: null,
  orgID: null,
  phoneNumber: null,
  profilePicture: null,
  purpose: null,
  securityStatus: null,
  visitDateTime: null,
  visitorAddress: null,
  visitorID: null,
  securityCode: null,
  qrCode: null,
  isHostVerified: '0',
  isGateEntry: null,
  isPreApproved: null,
  checkIn: null,
  checkOut: null,
  guardAtDutyID: null,
  guardAtDutyName: null,
  ePassValidity: null,
  visitorTimline: null,
  visitorCategory: null,
  visitorTimlineListUI: [],
  timer: null,
  visitorType: null,
  meetingComments: null,
  inProgressStatusTime: null,
  completeStatusTime: null,
  timerValue: null,
  visitorTimelineGraph: [],
  visitorComments: [],
  isTwoFactor: false,
  isLocationVerify: false,
  visitorLocation: null,
};
export interface VisitorTimeline {
  index: number;
  checkIn: Date;
  checkOut: Date;
}
export interface VisitorBreakdownGraph {
  visitDate: Date;
  visitorCount: number;
  gateEntryCount: number;
  preVerifiedCount: number;
  preApprovedCount: number;
  rapidVisitorCount: number;
}
export interface VisitorStatusTimeline {
  index: number;
  status: number;
  date: Date;
  time: number;
}
